const isBoolean = (value) => typeof value === 'boolean';

export default isBoolean;
